import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import { useTranslation } from 'react-i18next';
import { getTapLogs } from '../../apis/services';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';

const PaymentLogs = () => {
    const { t } = useTranslation();
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [phone, setPhone] = useState();
    const [trackId, setTrackId] = useState();
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    useEffect(() => {
        loadLogs();
    }, []);


    const formatDate = (date) => {
        return date.getFullYear() + "-" +
            String(date.getMonth() + 1).padStart(2, '0') + "-" +
            String(date.getDate()).padStart(2, '0') + " " +
            String(date.getHours()).padStart(2, '0') + ":" +
            String(date.getMinutes()).padStart(2, '0') + ":" +
            String(date.getSeconds()).padStart(2, '0');
    };

    const getStartOfDay = (date) => {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return formatDate(d);
    };

    const getEndOfDay = (date) => {
        const d = new Date(date);
        d.setHours(23, 59, 59, 999);
        return formatDate(d);
    };


    const loadLogs = async () => {
        try {
            let params = {
                phone: phone,
                trackId: trackId,
                startDate: startDate === undefined ? '' : getStartOfDay(startDate),
                endDate: endDate === undefined ? '' : getEndOfDay(endDate),
            };
            setLoading(true);
            const res = await getTapLogs(params);
            setLogs(res.data.logs);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    }
    return (
        <div className="p-3">
            <div className="glass-card p-3">
                <DataTable
                    value={logs}
                    paginator
                    rows={10}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[10, 25, 50]}
                    dataKey="transaction"
                    selectionMode="checkbox"
                    filterDisplay="menu"
                    emptyMessage={t('data_not_available')}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    filters={filters}
                    header={
                        <div className='row'>
                            <div className="col-md-4 mb-2">
                                <input className='form-control'
                                    placeholder={t('search')}
                                    onChange={(e) => {
                                        let _filters = { ...filters };
                                        _filters['global'].value = e.target.value;
                                        setFilters(_filters);
                                    }}
                                />
                            </div>
                            <div className="col-md-4 mb-2">
                                <input type="text" name="" id="" className='form-control' placeholder={t('phone')}
                                    value={phone}
                                    onChange={(e) => {
                                        setPhone(e.target.value);
                                    }}
                                />
                            </div>
                            <div className="col-md-4 mb-2">
                                <input type="text" name="" id="" className='form-control' placeholder={t('track_id')}
                                    value={trackId}
                                    onChange={(e) => {
                                        setTrackId(e.target.value);
                                    }}
                                />
                            </div>
                            <div className="col-md-4 mb-2">
                                <div className="d-flex">
                                    <Calendar className='pr-input' placeholder={t('start_date')}
                                        value={startDate}
                                        maxDate={new Date()}
                                        onChange={(e) => {
                                            setStartDate(e.value)
                                        }}
                                    />
                                    <Calendar className='pr-input' placeholder={t('end_date')}
                                        maxDate={new Date()}
                                        value={endDate}
                                        onChange={(e) => {
                                            setEndDate(e.value)
                                        }}

                                    />
                                </div>
                            </div>
                            <div className="col-md-2 mb-2">
                                <Button className='rounded-btn' label={t('search')} loading={loading}
                                    onClick={() => {
                                        loadLogs();
                                    }}
                                />
                                <Button className='rounded-btn mx-2' severity='info' label={t('reset')} loading={loading}
                                    onClick={() => {
                                        setTrackId("");
                                        setPhone("");
                                        setStartDate();
                                        setEndDate();
                                        loadLogs();
                                    }}
                                />
                            </div>
                        </div>
                    }
                >

                    <Column
                        field="charge_id"
                        header={t('track_id')}
                        sortable
                    />
                    <Column
                        field="name"
                        header={t('name')}
                        sortable
                    />

                    <Column
                        field="phone"
                        header={t('phone')}
                        sortable
                    />
                    <Column
                        field="amount"
                        header={t('amount')}
                        sortable
                    />
                    <Column
                        field="notes"
                        header={t('notes')}
                        sortable
                    />
                    <Column
                        field="payment_status"
                        header={t('status')}
                        sortable
                    />
                    <Column
                        field="charge_id"
                        header={t('TAP-ID')}
                        sortable
                    />
                    <Column
                        field="created_at"
                        header={t('date')}
                        sortable
                    />




                </DataTable>
            </div>
        </div>
    );
}
export default PaymentLogs